import 'angular';

import './admin-reports/admin-reports.module.ajs';

import { ReportsLiteCtrl } from './reports';

angular.module('app-lite.reports', [
    'app-lite.admin-reports'
  ])
  .controller('ReportsLiteCtrl', ReportsLiteCtrl);
